import Money from '@square/dashboard-money/models/money';
export default {
  serialize(money) {
    if (money !== null && money !== undefined) {
      return {
        amount: money.amount,
        currency_code: money.currencyCode
      };
    }
    return undefined;
  },
  deserialize(proto) {
    if (proto !== null && proto !== undefined) {
      return Money.fromCents(proto.amount, proto.currency_code);
    }
    return undefined;
  }
};